import { AWSError } from 'aws-sdk/lib/error';
import { Request } from 'aws-sdk/lib/request';
import { getCredentials } from './auth';
import { initCatalogClient } from './catalog';
import { initDatasetServiceClient } from './ingestion';
import { initNotificationsClient } from './notifications';
import { initGladstoneClient } from './permissions';
import { initResourcesManagerClient } from './resourcesmanager';
import { initAccessLogCollectorClient } from './usageStats';
import { initMetricStoreClient } from './metricstore';
import { initLatticeWithCredentials } from 'src/api/latticelineage';
import { initRumClient } from 'src/api/rum';
import { initD3AServiceClient } from 'src/api/d3a';

export default function basicCallWrapper<I, O, E = AWSError>(
  client: any,
  apiFunc: (input: I, callback?: (err: E, data: O) => void) => Request<O, E>,
) {
  return (input: I) => {
    return new Promise<O>((resolve, reject) => {
      apiFunc.call(client, input, (err, createData: O) => {
        if (err) {
          reject(err);
        } else {
          resolve(createData);
        }
      });
    });
  };
}

export async function initAllClients() {
  const credentials = await getCredentials();
  initCatalogClient(credentials);
  initDatasetServiceClient(credentials);
  initNotificationsClient(credentials);
  initGladstoneClient(credentials);
  initResourcesManagerClient(credentials);
  initAccessLogCollectorClient(credentials);
  initMetricStoreClient(credentials);
  initD3AServiceClient(credentials);
  initLatticeWithCredentials(credentials);
  initRumClient(credentials);
}
